import { useEffect, useRef, useState } from "react";

const PING_URL = "/services/ping";
const PING_INTERVAL_MS = 10000;
const SLOW_THRESHOLD_MS = 2000;
const WINDOW_SIZE = 5;
const FAILURE_RATIO = 0.6;

export function useSlowConnection() {
	const [isSlow, setIsSlow] = useState(false);
	const results = useRef<boolean[]>([]);

	useEffect(() => {
		async function ping() {
			const start = performance.now();

			try {
				const controller = new AbortController();
				const timeout = setTimeout(() => controller.abort(), SLOW_THRESHOLD_MS);

				await fetch(PING_URL, {
					method: "HEAD",
					cache: "no-store",
					signal: controller.signal,
				});
				clearTimeout(timeout);

				const elapsed = performance.now() - start;
				results.current.push(elapsed >= SLOW_THRESHOLD_MS);
			} catch {
				results.current.push(true);
			}

			if (results.current.length > WINDOW_SIZE) {
				results.current = results.current.slice(-WINDOW_SIZE);
			}

			const failures = results.current.filter(Boolean).length;
			setIsSlow(
				results.current.length >= 3 &&
					failures / results.current.length >= FAILURE_RATIO
			);
		}

		ping();
		const timer = setInterval(ping, PING_INTERVAL_MS);

		return () => clearInterval(timer);
	}, []);

	return isSlow;
}
